module.exports = __webpack_public_path__ + "img/xianxia.c514752e.png";